import React from 'react';
import PropTypes from 'prop-types';
import { withApi } from '@tencent/react-aio';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import MessageBox from '@/components/MessageBox';
import { formatSeconds } from '@/utils/TimeUtils';

class Footer extends React.PureComponent {
  static propTypes = {
    loginStatus: PropTypes.object,
  }

  state = {
    statusBarData: undefined,
    employeeUser: undefined,
  }

  componentDidMount() {
    this.getSeatInfoAndStatusBar();
  }

  getSeatInfoAndStatusBar = () => {
    const { webApi } = this.props;
    webApi
      .getCurrentEmployeeUser()
      .ajax()
      .then((res) => {
        this.setState({
          employeeUser: res,
        });
        // 用户有坐席才去获取工作条信息
        if (this.state.employeeUser && this.state.employeeUser.seatNo) {
          this.fetchStatusBar();
        }
      });
  }

  fetchStatusBar = () => {
    const { webApi } = this.props;
    webApi
      .fetchStatusBar()
      .ajax()
      .then(
        (statusBarData) => {
          this.setState(
            {
              statusBarData,
            },
            () => {
              if (statusBarData) {
                document.querySelector('#root').classList.add('with-footer');
              } else {
                document.querySelector('#root').classList.remove('with-footer');
              }
            },
          );
          setTimeout(this.fetchStatusBar, 60000);
        },
        (err) => {
          if(window.tccc && err.status === 401) {
            // 登录失效，关闭t3c的登录状态，避免可以接听电话
            window.tccc.Agent.offline();
          }
          setTimeout(this.fetchStatusBar, 60000);
        },
      );
  }

  render() {
    const { loginStatus } = this.props;
    // console.log(loginStatus);
    const { statusBarData, employeeUser } = this.state;
    // 如果获取用户信息失败（登录状态、雇员信息），则不显示工作条
    if (!loginStatus.authorized || undefined === employeeUser) {
      return null;
    }
    // 如果获取到用户坐席号为空，则不显示工作条
    if (undefined === employeeUser.seatNo) {
      return null;
    }
    // 如果获取到statusBarData不为空，则显示工作条
    if (statusBarData !== undefined) {
      const { dialOutTimesTotal, dialOutTimesConnected, dialOutSecondsTalkTotal, dialOutTimesMoreThan1min, leadCountCreated, potentialCountCreated } = statusBarData;
      return (
        <div id="footer">
          呼出电话总量：{dialOutTimesTotal ? dialOutTimesTotal : 0}&emsp;&emsp; 接通电话总量：{dialOutTimesConnected ? dialOutTimesConnected : 0}&emsp;&emsp; 1min以上的通话数：{dialOutTimesMoreThan1min ? dialOutTimesMoreThan1min : 0}&emsp;&emsp; 呼出总通时：
          {dialOutSecondsTalkTotal ? this.renderDialOutSecondsTalkTotal(dialOutSecondsTalkTotal) : '00:00:00'}&emsp;&emsp; 新增线索数：{leadCountCreated ? leadCountCreated : 0}&emsp;&emsp; 新增商机数：{potentialCountCreated ? potentialCountCreated : 0}
        </div>
      );
    }
    return null;
  }

  renderDialOutSecondsTalkTotal = (dialOutSecondsTalkTotal) => {
    return formatSeconds(dialOutSecondsTalkTotal);
  }
}

function mapStateToProps(state, ownProps) {
  return {
    loginStatus: state.loginStatus,
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default withApi(withRouter(connect(mapStateToProps, mapDispatchToProps)(Footer)));

Footer.contextType = MessageBox;
